import { render } from "./ModalSetGateways.vue?vue&type=template&id=74078cc8&scoped=true&ts=true"
import script from "./ModalSetGateways.vue?vue&type=script&lang=ts"
export * from "./ModalSetGateways.vue?vue&type=script&lang=ts"

import "./ModalSetGateways.vue?vue&type=style&index=0&id=74078cc8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74078cc8"]])

export default __exports__